/**
 * Licensed Materials - Property of IBM
 *
 * "Restricted Materials of IBM"
 *
 * (C) Copyright IBM Corp. 2018, 2020
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 *  This class works as an apdater of SlotAPI Class (please find SlotAPI in dashboard-livewidget for more informaiton)
 *  This adapter is needed when creating VIPRData for Relationship Diagram
 **/
export default class SlotAPIAdapter {
	/**
	 *@constructor
	 *@param slotDef - Original Slot definition returned from VIDA Vis definition
	 */
	constructor(slotDef){
		this.slotDef = slotDef;
		if (slotDef.datasetIdList[0] === 'data.nodes') {
			if ('nodeColor' === slotDef.id && 'any' === slotDef.type) {
				slotDef.type = 'category';
			}
		}
	}

	/**
	 *@return the ID of the slot
	 */
	getId(){
		return this.slotDef.id;
	}

	/*
	 * called in visualizations/vipr/VIPRData->VIPRDataSet->init()
	 */
	getDataItemList(){
		return [{
			getId: ()=> {},
			getColumnId: ()=> {},
			getType : ()=> {
				if(this.slotDef.type === 'category'){
					return 'attribute'; //Legacy 'final type' in R5
				}
				return this.slotDef.type;
			},
			getFormat: ()=> {}
		}];
	}

	isStacked(){
		return false;
	}

	getType() {
		return this.slotDef.type;
	}

	/*
	 * called in visualizations/vipr/VIPRData->SlotAPIHelper->getMappedSlotListByDataset()
	 */
	getDefinition() {
		return {
			getDataset: () => this.slotDef.dataset,
			getDatasetIdList: ()=> this.slotDef.datasetIdList,
			isMultiMeasureSupported: ()=> false
		};
	}

	/*
	 * called in visualizations/vipr/VIPRData->getItem()
	 */
	isCaptionAsUniqueName() {
		return false;
	}

}



// WEBPACK FOOTER //
// ./src/js/components/startingPoints/relationshipGraph/SlotAPIAdapter.js